import Cookies from '@mentimeter/cookies';
import { DEVELOPMENT_FLAGS_KEY } from './constants';

export function getDevelopmentFlagOverrides(): Record<string, string> {
  return Cookies.getJSON(DEVELOPMENT_FLAGS_KEY) ?? {};
}
